// extracted by mini-css-extract-plugin
export var headline6 = "bz_fm";
export var menuContainer = "bz_fj";
export var menuItem = "bz_fl";
export var menuList = "bz_fk";